import { apiProvider } from '@/services/utilities/Provider';

const getByClient = (clientId, page = 1, pageSize = 20) =>
    apiProvider.get(`/admin/clients/${clientId}/workflows?page=${page}&pageSize=${pageSize}`);

const getById = (id) =>
    apiProvider.get(`/admin/workflows/${id}`);

const getScoringModel = (id) =>
    apiProvider.get(`/admin/workflows/${id}/scoring-model`);

const create = (clientId, data) =>
    apiProvider.post(`admin/clients/${clientId}/workflows`, data);

const update = (id, data) =>
    apiProvider.put(`admin/workflows/${id}`, data);

const WorkflowService = { getByClient, getById, getScoringModel, create, update };
export default WorkflowService;
